<section>
  <div class="global-hero__container position-relative mx-auto">
    <div class="photo position-absolute"></div>
    <div
      class="global-hero__content bg-primary position-relative d-flex flex-column flex-md-row justify-content-md-end align-items-center">
      <div class="photo-frame position-relative">
        <div class="alt-text position-absolute z-1 text-white"></div>
        <div class="photo-frame__bottom d-none d-md-block d-lg-none w-100 bg-white position-absolute z-1 bottom-0">
        </div>
      </div>
      <div class="text-box z-1 bg-white text-dark d-flex flex-column justify-content-center">
        <h1 class="text-uppercase">
          <span>SITEMAP</span>
        </h1>
      </div>
    </div>
  </div>
</section>

<section container class="links-container">
  <div class="site-map__container">
    <a
      *ngIf="homeRoute"
      class="site-map__home text-decoration-none text-black fw-bold"
      [routerLink]="homeRoute.url"
      >{{ homeRoute.text }}</a
    >

    <div class="site-map__group" *ngFor="let group of routeGroups; index as i">
      <p class="site-map__heading text-black fw-bold">{{ group.heading }}</p>

      <div class="site-map__links">
        <a
          class="site-map__link"
          *ngFor="let route of group.links"
          [routerLink]="route.url"
          >{{ route.text }}</a
        >
      </div>

      <a
        *ngIf="i === 1 && howToScreenRoute"
        class="site-map__link site-map__link--main"
        [routerLink]="howToScreenRoute.url"
        >{{ howToScreenRoute.text }}</a
      >
    </div>
  </div>
</section>
<review-bar [isUpdated]="true" dateText="in August 2026"></review-bar>
